module.exports = __webpack_public_path__ + "img/forecast.0eb5fa76.png";